
import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import {
    EMBEDDED_COLLECTION_COLUMN_URI,
    EMBEDDED_ITEM_COLUMN_URI,
    TWOCOLUMNSTABLE_URI
} from '@grupo-constant/next-dtype/types';
import { DtypeItemComponent } from '../dtype-item/dtype-item.component';

@Component({
    selector: 'dtype-component-list',
    templateUrl: 'dtype-component-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, forwardRef(() => DtypeItemComponent)]
})
export class DtypeComponentListComponent {

    @Input() dtypeForm: DTypeForm;
    @Input() isUpdate = false;

    embeddedItemUri = EMBEDDED_ITEM_COLUMN_URI;
    embeddedItemCollectionUri = EMBEDDED_COLLECTION_COLUMN_URI;
    twoColumnsTable = TWOCOLUMNSTABLE_URI;

}
